define('views/app/zoom',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'bootbox',
    // services
    'services/user',
    'services/toastr-service',
    'services/api',
    'services/session',
    // models & collections
    'collections/payment/team-payments',
    'collections/payment/membership-plans',
    // views
    'views/modules/setting/business/modals/payment-expired-group-modal',
    'views/modules/setting/business/modals/payment-finish-process-modal',
    'views/modules/setting/business/modals/payment-add-method-modal',
    // templates
    'text!templates/app/zoom/zoom.html',

], function(
    // Libs
    _, Backbone, Mustache, U, Bootbox,
    // services
    User,
    ToastrService,
    API,
    Session,
    // models & collections
    CTeamPayments,
    CMembershipPlans,
    // views
    VPaymentExpiredGroupModal,
    VPaymentFinishProcessModal,
    VPaymentAddMethodModal,
    // templates
    TLayoutZoom
) {

    var VZoomLayout = Backbone.View.extend({
        template: TLayoutZoom,
        id: "zoom-layout",

        regions: {
            modal: "#zoom-modal",
        },

        initialize: function(opt) {
            this.options = _.extend(opt, this.options);
        },

        render: function() {
            this.$el.empty()
                .append(Mustache.render(this.template, Mustache.getContext()));

            if (this.view && this.view.modal) {
                this.generateZones()
                    .assign(this.view.modal, this.zone.$modal);
            }

            return this;
        },

        loginWithZoom: function(code) {
            if (! Session.isAuthenticated()) {
                ToastrService.error("please-login-to-enable-zoom-integration");
                window.location.href = "#/auth/login";
            } else {
                Backbone.ajax({
                    url: API.url('users/me/zoom/?code=' + code),
                    method: 'POST',
                    success: function() {
                        ToastrService.success('connection-successful');
                        setTimeout(function() {
                            window.location.href = "/#supervisor";
                        }, 3000);
                    },
                    error: function(response) {
                        ToastrService.error('we-encountered-a-problem-with-zoom');
                        window.Rollbar.error("Problème de connexion avec Zoom (login-with-zoom-modal) \n" + User.get('email') + "\n" + response.responseText);
                        setTimeout(function() {
                            window.location.href = "/#supervisor";
                        }, 3000);
                    }
                });
            }
        }

    });

    return VZoomLayout;
});

